import useCompanyPaymentMethods from 'modules/companies/hooks/use-company-payment-methods';
import {PaymentMethodProps} from 'modules/payment-methods/types';
import React from 'react';
import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';
import useOrder from '../hooks/use-order';
import useChangePaymentMethod from '../hooks/use-change-payment-method';

const ChangePaymentMethod: React.FC = () => {
  const {id} = useParams() as {id: string};

  const {getSelect, getPriceInput, getInput} =
    useFormInputs<PaymentMethodProps>();
  const orderQuery = useOrder(id);
  const {data = [], isLoading} = useCompanyPaymentMethods(
    orderQuery.data?.companyId,
  );

  const handleSubmit = ({name, change, pixChange}: PaymentMethodProps) => {
    const paymentMethod = data.find(
      (somePaymentMethod) => somePaymentMethod.value === name,
    );

    if (!paymentMethod) return;

    return {name: paymentMethod.data?.name, change, pixChange};
  };

  return (
    <Creation
      {...{
        inputs: [
          getSelect({
            name: 'name',
            data,
            isLoading,
          }),
          getPriceInput({
            name: 'change',
            placeholder: 'Troco para?',
            hidden: (data) => data.name !== '66f195c79c2c50bec5b77b64',
          }),
          getInput({
            name: 'pixChange',
            hidden: (data) => data.name !== '66f195c79c2c50bec5b77b64',
          }),
        ],
        translationKey: 'PaymentMethodProps',
        onSubmit: () => useChangePaymentMethod(id),
        handleSubmit,
      }}
    />
  );
};

export default ChangePaymentMethod;
